module.exports = __webpack_public_path__ + "static/media/alatmusik.70a4d463.jpeg";